import { Gravatar } from '@startuptools/ui/Gravatar';
import { Avatar } from '@startuptools/ui/Avatar';
import { AvatarGroup } from '@startuptools/ui/AvatarGroup';
import { GqlIdentity } from '../../../graphql/base-types.graphql';

const take = 3;

type I = Pick<GqlIdentity, 'emailMd5' | 'id' | 'name'>;

export const CompanyDocumentsSignatures = ({
  documentSignatures,
}: {
  documentSignatures: { id: string; proxy?: I | null | undefined; signatory: I }[];
}) => {
  const rest = documentSignatures.length - take;

  return (
    <AvatarGroup>
      {documentSignatures.slice(0, take).map(ds => {
        const identity = ds.proxy || ds.signatory;
        return (
          <Gravatar key={ds.id} md5Hash={identity.emailMd5 ?? ''} uuid={identity.id} size="sm">
            {identity.name[0]}
          </Gravatar>
        );
      })}
      {rest > 0 && <Avatar size="sm">+{rest}</Avatar>}
    </AvatarGroup>
  );
};
